import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { initPerfProbe } from "./services/perfProbe";

// مقياس تأخّر الاستجابة — لا يعمل إلا مع ?perf=1 (راجع perfProbe.ts).
initPerfProbe();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
